// import Vue from 'vue';
// import Vuex from 'vuex';
import Axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
// Vue.use(Vuex);
const getDefaultState = () => {
    return {
        token: '',
        user: {},
        unit: -1,
        role: -1
    };
};

import { createStore } from 'vuex'

export default createStore({
// export default new Vuex.Store({
    strict: true,
    plugins: [createPersistedState()],
    state: getDefaultState(),
    getters: {
        isLoggedIn: state => {
            return state.token;
        },
        getUser: state => {
            return state.user;
        },
        getUnit: state => {
            return state.unit;
        },
        getRole: state => {
            return state.role;
        },
        getEmail: state => {
            return state.email;
        }
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_UNIT: (state, unit) => {
            state.unit = unit;
        },
        SET_ROLE: (state, role) => {
            state.role = role;
        },
        SET_EMAIL: (state, email) => {
            state.email = email;
        },
        RESET: state => {
            Object.assign(state, getDefaultState());
        }
    },
    actions: {
        login: ({ commit, dispatch }, { token, user, unit, role, email }) => {
            commit('SET_TOKEN', token);
            commit('SET_USER', user);
            commit('SET_UNIT', unit);
            commit('SET_ROLE', role);
            commit('SET_EMAIL', email);
            // set auth header
            Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },
        logout: ({ commit }) => {
            commit('RESET', '');
        }
    }
});
